import { BaseInstrumentation, dateNow, EVENT_SESSION_EXTEND, EVENT_SESSION_RESUME, EVENT_SESSION_START, VERSION, } from '@grafana/faro-core';
import { createSession } from '../../metas';
import { isSampled } from './sessionManager';
import { PersistentSessionsManager } from './sessionManager/PersistentSessionsManager';
import { createUserSessionObject, isUserSessionValid } from './sessionManager/sessionManagerUtils';
import { VolatileSessionsManager } from './sessionManager/VolatileSessionManager';
export class SessionInstrumentation extends BaseInstrumentation {
    constructor() {
        super(...arguments);
        this.name = '@grafana/faro-web-sdk:instrumentation-session';
        this.version = VERSION;
    }
    sendSessionStartEvent(meta) {
        var _a, _b;
        const session = meta.session;
        if (session && session.id !== ((_a = this.notifiedSession) === null || _a === void 0 ? void 0 : _a.id)) {
            if (this.notifiedSession && this.notifiedSession.id === ((_b = session.attributes) === null || _b === void 0 ? void 0 : _b['previousSession'])) {
                this.api.pushEvent(EVENT_SESSION_EXTEND, {}, undefined, { skipDedupe: true });
                this.notifiedSession = session;
                return;
            }
            this.notifiedSession = session;
            // no need to add attributes and session id, they are included as part of meta
            // automatically
            this.api.pushEvent(EVENT_SESSION_START, {}, undefined, { skipDedupe: true });
        }
    }
    createInitialSessionMeta(sessionsConfig) {
        var _a, _b, _c;
        const sessionManager = sessionsConfig.persistent ? PersistentSessionsManager : VolatileSessionsManager;
        let userSession = sessionManager.fetchUserSession();
        if (sessionsConfig.persistent && sessionsConfig.maxSessionPersistenceTime && userSession) {
            const now = dateNow();
            const shouldClearPersistentSession = userSession.lastActivity < now - sessionsConfig.maxSessionPersistenceTime;
            if (shouldClearPersistentSession) {
                PersistentSessionsManager.removeUserSession();
                userSession = null;
            }
        }
        let sessionId = (_a = sessionsConfig.session) === null || _a === void 0 ? void 0 : _a.id;
        let sessionAttributes = (_b = sessionsConfig.session) === null || _b === void 0 ? void 0 : _b.attributes;
        let lifecycleType;
        if (isUserSessionValid(userSession)) {
            sessionId = userSession === null || userSession === void 0 ? void 0 : userSession.sessionId;
            sessionAttributes = Object.assign(Object.assign(Object.assign({}, sessionAttributes), (_c = userSession === null || userSession === void 0 ? void 0 : userSession.sessionMeta) === null || _c === void 0 ? void 0 : _c.attributes), { isSampled: (userSession.isSampled || false).toString() });
            lifecycleType = EVENT_SESSION_RESUME;
        }
        else {
            sessionId = sessionId !== null && sessionId !== void 0 ? sessionId : createSession().id;
            lifecycleType = EVENT_SESSION_START;
        }
        const sessionMeta = {
            id: sessionId,
            attributes: Object.assign({ isSampled: isSampled().toString() }, sessionAttributes),
        };
        return { sessionMeta, lifecycleType };
    }
    registerBeforeSendHook(SessionManager) {
        var _a;
        const { updateSession } = new SessionManager();
        (_a = this.transports) === null || _a === void 0 ? void 0 : _a.addBeforeSendHooks((item) => {
            var _a, _b, _c;
            updateSession();
            const attributes = (_a = item.meta.session) === null || _a === void 0 ? void 0 : _a.attributes;
            if (attributes && (attributes === null || attributes === void 0 ? void 0 : attributes['isSampled']) === 'true') {
                let newItem;
                // Structured clone is supported in all major browsers
                // but for old browsers we need a fallback
                if ('structuredClone' in window) {
                    newItem = structuredClone(item);
                }
                else {
                    newItem = JSON.parse(JSON.stringify(item));
                }
                const newAttributes = (_b = newItem.meta.session) === null || _b === void 0 ? void 0 : _b.attributes;
                newAttributes === null || newAttributes === void 0 ? true : delete newAttributes['isSampled'];
                if (Object.keys(newAttributes !== null && newAttributes !== void 0 ? newAttributes : {}).length === 0) {
                    (_c = newItem.meta.session) === null || _c === void 0 ? true : delete _c.attributes;
                }
                return newItem;
            }
            return null;
        });
    }
    initialize() {
        var _a, _b;
        this.logDebug('init session instrumentation');
        const sessionTracking = this.config.sessionTracking;
        if (sessionTracking === null || sessionTracking === void 0 ? void 0 : sessionTracking.enabled) {
            const SessionManager = ((_a = this.config.sessionTracking) === null || _a === void 0 ? void 0 : _a.persistent)
                ? PersistentSessionsManager
                : VolatileSessionsManager;
            this.registerBeforeSendHook(SessionManager);
            const { sessionMeta: initialSessionMeta, lifecycleType } = this.createInitialSessionMeta(sessionTracking);
            SessionManager.storeUserSession(Object.assign(Object.assign({}, createUserSessionObject({
                sessionId: initialSessionMeta.id,
                isSampled: ((_b = initialSessionMeta.attributes) === null || _b === void 0 ? void 0 : _b['isSampled']) === 'true',
            })), { sessionMeta: initialSessionMeta }));
            this.notifiedSession = initialSessionMeta;
            this.api.setSession(initialSessionMeta);
            if (lifecycleType === EVENT_SESSION_START) {
                this.api.pushEvent(EVENT_SESSION_START, {}, undefined, { skipDedupe: true });
            }
            if (lifecycleType === EVENT_SESSION_RESUME) {
                this.api.pushEvent(EVENT_SESSION_RESUME, {}, undefined, { skipDedupe: true });
            }
        }
        this.metas.addListener(this.sendSessionStartEvent.bind(this));
    }
}
//# sourceMappingURL=instrumentation.js.map